import React from 'react';

const labels = {
  draft: 'Rascunho',
  in_review: 'Em Revisão',
  in_approval: 'Em Aprovação',
  approved: 'Aprovado',
  rejected: 'Rejeitado',
  // Versao anterior que ja passou pela aprovacao e foi substituida
  superseded: 'Substituída',
};

export default function StatusStamp({ status }) {
  return (
    <span className={`status-stamp ${status}`}>
      {labels[status] || status}
    </span>
  );
}
